angular
    .module('app')
    .directive('dropdownMonth', DropdownMonth);

DropdownMonth.$inject = [];
function DropdownMonth() {
    function getMonths(){
        var months = {
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December"
        };
        return months;
    }
    return {
        restrict: 'A',
        scope: {
            ngModel: '=',
        },
        link: function(scope, element, attrs){
            scope.months = getMonths();
        },
        template:   '<label class="small" translate>Month</label>' + 
                    '<select class="form-control input-sm" ng-model="ngModel">' + 
                    '<option value="" translate>Any</option>' + 
                    '<option ng-repeat="m in months" value="{{$index+1}}" translate>{{m}}</option>' +
                    '</select>'
    };
}
